import React, { useState } from "react";
import { Check, ChevronRight } from "lucide-react";

import GroupEntry from "../../pages/user/form/groupEntry/EntryForm";

interface LinkItem {
  title: string;
  description?: string;
  check: boolean;
  component: React.ComponentType;
}

const links: LinkItem[] = [
  {
    title: "JBC応募",
    check: true,
    component: GroupEntry,
  },
  {
    title: "演奏曲提出",
    check: true,
    component: GroupEntry,
  },
  {
    title: "写真提出",
    check: false,
    component: GroupEntry,
  },
];

const PortalEntry: React.FC = () => {
  const [activeComponent, setActiveComponent] =
    useState<React.ComponentType | null>(null);

  if (activeComponent) {
    const ActiveComponent = activeComponent;

    return <ActiveComponent />;
  }

  return (
    <div className="portal-entry-links">
      <ul className="entry-list">
        {links.map((link) => (
          <li
            key={link.title}
            className="link-card"
            onClick={() =>
              setActiveComponent(() => link.component)
            }
          >
            {link.check && (
              <div className="checked">
                <Check size={48} strokeWidth={3} />
              </div>
            )}

            <div className="title">{link.title}</div>

            <div className="arrow">
              <ChevronRight />
            </div>

            {link.description && (
              <div className="description">
                {link.description}
              </div>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PortalEntry;